import apiFetch from '../apiFetch'

export default function (token, data) {
  return apiFetch({ endPoint: 'Fleets/FindFleetManagerExport', method: 'POST', body: data, token: token, parseBlobAndAssign: true })
}
